import CookiesStorage from '@/common/auth/storage/auth-token-cookies'

/** @type {AppConfig} */
const config = {
  get authStorageDriver () {
    return new CookiesStorage()
  },
  get apiUrl () {
    return process.env.API_URL
  },
  get ssoUrl () {
    return `${process.env.SSO_URL}`
  },
  get ssoSignInUrl () {
    return `${this.ssoUrl}?client_id=${process.env.SSO_CLIENT_ID}`
  },
  get ssoSignOutUrl () {
    return `${this.ssoUrl}?logout`
  },
  get rootParentId () {
    return process.env.ROOT_PARENT_ID
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js